// removed by extract-text-webpack-plugin
module.exports = {"timer":"Timer-timer--_2kNL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Timer/Timer.scss
// module id = aFXg
// module chunks = 1